import { forwardRef, type Ref } from 'react'
import classNames from 'classnames'
import styles from './styles.module.scss'

export type ITextareaProps = {
  placeholder?: string
  error?: boolean | null
  limitWarning?: boolean
  value: string
  rows?: number
  onBlur?: (value: string) => void
  onChange: (value: string) => void
  className?: string
}

export const TextareaRef = (
  {
    placeholder,
    error,
    limitWarning = false,
    value,
    rows = 4,
    onBlur,
    onChange,
    className,
  }: ITextareaProps,
  ref: Ref<HTMLTextAreaElement>
) => {
  return (
    <div
      className={classNames(styles.textareaWrap, {
        [styles.textareaError]: error,
        [styles.textareaLimitWarning]: limitWarning,
      })}
    >
      <textarea
        ref={ref}
        rows={rows}
        className={classNames(styles.textarea, className)}
        placeholder={placeholder}
        value={value}
        onBlur={({ target }) => onBlur?.(target.value)}
        onChange={({ target }) => onChange(target.value)}
      />
    </div>
  )
}

export const Textarea = forwardRef(TextareaRef)
